/**
 * @generated SignedSource<<c6f1216bf9bbd1fb08a77b3b6b110158>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dividendsPage_DateUpdateMutation$variables = {
  from: any;
  to: any;
};
export type dividendsPage_DateUpdateMutation$data = {
  readonly capTableDateUpdate: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly moved: boolean | null | undefined;
  } | null | undefined;
};
export type dividendsPage_DateUpdateMutation = {
  response: dividendsPage_DateUpdateMutation$data;
  variables: dividendsPage_DateUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "from"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "to"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "to",
    "variableName": "to"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "moved",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dividendsPage_DateUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CapTableDateUpdateMutationPayload",
        "kind": "LinkedField",
        "name": "capTableDateUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dividendsPage_DateUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CapTableDateUpdateMutationPayload",
        "kind": "LinkedField",
        "name": "capTableDateUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0186996e17293c98712b52ee22e06508",
    "id": null,
    "metadata": {},
    "name": "dividendsPage_DateUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation dividendsPage_DateUpdateMutation(\n  $from: ISO8601Date!\n  $to: ISO8601Date!\n) {\n  capTableDateUpdate(from: $from, to: $to) {\n    moved\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "69d1c5cca6be1562f9f72f638c59c558";

export default node;
